import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { Monitor, Smartphone, Apple, Download, Sparkles } from 'lucide-react';

export const DownloadPage: React.FC = () => {
  const downloads = [
    {
      platform: 'Windows Desktop',
      icon: Monitor,
      description: 'Native Windows application powered by Tauri v2 with native notifications and low memory footprint.',
      formats: [
        { label: 'Installer (.msi)', link: '#' },
        { label: 'Standalone (.exe)', link: '#' },
      ],
      recommended: true,
    },
    {
      platform: 'macOS Desktop',
      icon: Apple,
      description: 'Universal macOS app optimized for Apple Silicon (M1/M2/M3/M4) and Intel Macs.',
      formats: [
        { label: 'Universal (.dmg)', link: '#' },
      ],
      recommended: false,
    },
    {
      platform: 'Android Mobile',
      icon: Smartphone,
      description: 'Full-featured mobile client powered by React Native and Expo with push notifications.',
      formats: [
        { label: 'Google Play Store', link: '#' },
        { label: 'Direct APK Download', link: '#' },
      ],
      recommended: false,
    },
    {
      platform: 'iOS Mobile',
      icon: Smartphone,
      description: 'Fast, responsive iPhone and iPad application with background synchronization.',
      formats: [
        { label: 'Apple App Store', link: '#' },
      ],
      recommended: false,
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F9FB] text-[#1a1b4b] antialiased selection:bg-[#3a9efd]/20 selection:text-[#1a1b4b]">
      <Navbar />
      <main className="flex-1 pt-28 pb-20">
        <div className="container mx-auto max-w-7xl px-4 sm:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#292a73]/10 border border-[#3e4491]/20 text-[#292a73] text-xs font-bold">
              <Sparkles className="h-3.5 w-3.5 text-[#f7a400]" />
              <span>Native Multi-Platform Clients</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-[#1a1b4b]">
              Download{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#292a73] via-[#3a9efd] to-[#f7a400]">
                Sahaj Connect.
              </span>
            </h1>
            <p className="text-base text-[#3e4491] font-medium leading-relaxed max-w-2xl mx-auto">
              Stay connected across all your devices. Instant sync, low battery drain, and zero compromises.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {downloads.map((d, i) => {
              const Icon = d.icon;
              return (
                <div
                  key={i}
                  className={`p-8 rounded-3xl border-2 bg-white flex flex-col justify-between transition-all ${
                    d.recommended
                      ? 'border-[#3a9efd] shadow-xl shadow-[#292a73]/15 ring-2 ring-[#3a9efd]/20'
                      : 'border-[#3e4491]/20 shadow-sm hover:border-[#3a9efd]/60'
                  }`}
                >
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="w-12 h-12 rounded-2xl bg-[#292a73]/10 text-[#3a9efd] flex items-center justify-center">
                        <Icon className="h-6 w-6" />
                      </div>
                      {d.recommended && (
                        <span className="bg-[#f7a400]/20 text-[#1a1b4b] border border-[#f7a400]/40 text-xs font-bold px-3 py-1 rounded-full">
                          Recommended
                        </span>
                      )}
                    </div>
                    <h3 className="font-bold text-2xl text-[#1a1b4b]">{d.platform}</h3>
                    <p className="text-xs text-[#3e4491] font-medium leading-relaxed">{d.description}</p>
                  </div>

                  <div className="pt-8 flex flex-wrap gap-3">
                    {d.formats.map((f, j) => (
                      <a
                        key={j}
                        href={f.link}
                        className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#1a1b4b] hover:bg-[#292a73] text-white text-xs font-bold rounded-xl hover:shadow-md hover:shadow-[#1a1b4b]/25 transition"
                      >
                        <Download className="h-4 w-4 text-[#f7a400]" />
                        <span>{f.label}</span>
                      </a>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
